<div class="custom-dialog-wrapper">
  <h1 mat-dialog-title class="custom-dialog-title">Recommended ACL/ASL</h1>
  <div mat-dialog-content>

    <mat-horizontal-stepper class="stepper-container" linear #stepper [ngClass]="{hide:standardPurchaseModeView}"
      (selectionChange)="selectionChange($event)">
      
      <mat-step [label]="stepperLabels.RECOMMENDED_ACLASL">
        <p class="mt-3 mb-4">
          A recommended list of approved contractors and suppliers based on your item
          inputs
        </p>
        <div class="py-2" *ngIf="noItemsYet">
          <app-add-reference-card desc="You have no items which are applicable for recommendations" >
          </app-add-reference-card>
        </div>
        <div class="py-2" *ngIf="recommendedDataSource.data.length == 0 && !noItemsYet">
          <app-add-reference-card desc="You have no recommendations found for your items">
          </app-add-reference-card>
        </div>
        <div class="recommended-table-container" *ngIf="!noItemsYet && recommendedDataSource.data.length > 0">
          <div class="scrollmenu custom-table-wrapper--inner custom-table-wrapper--scroll-within">
            <table mat-table multiTemplateDataRows [dataSource]="recommendedDataSource"
              class="mat-elevation-z8 recommended-table">

              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox (change)="$event ? masterVToggle() : null"
                    [checked]="recommendedSelection.hasValue() && isAllVSelected()"
                    [indeterminate]="recommendedSelection.hasValue() && !isAllVSelected()">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox tabindex='0' (keypress)="$event.stopPropagation()" (click)="$event.stopPropagation()"
                    (change)="$event ? recommendedSelection.toggle(row) : null"
                    [checked]="recommendedSelection.isSelected(row)">
                  </mat-checkbox>
                </td>
              </ng-container>

              <ng-container matColumnDef="vendorName">
                <th mat-header-cell *matHeaderCellDef>Vendor Name</th>
                <td mat-cell *matCellDef="let element">{{ element.Name }}</td>
              </ng-container>
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>Type</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.VendorStatus }}
                </td>
              </ng-container>

              <ng-container matColumnDef="materialSubGroup">
                <th mat-header-cell *matHeaderCellDef>Material Sub Group</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.vendorMaterialGroup&& element.vendorMaterialGroup.length>0?
                  returnConcatenatedMaterialGroups(element):'-'}}
                </td>
              </ng-container>
              <ng-container matColumnDef="itemNos">
                <th mat-header-cell *matHeaderCellDef>Item No.</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.ItemNos||'-' }}
                </td>
              </ng-container>
              <ng-container matColumnDef="contactPerson">
                <th mat-header-cell *matHeaderCellDef>Contact Person</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.VendorContactPerson||'-' }}
                </td>
              </ng-container>
              <ng-container matColumnDef="vendorNo">
                <th mat-header-cell *matHeaderCellDef>Vendor No.</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.MPVendorDetailsId||'-' }}
                </td>
              </ng-container>
              <ng-container matColumnDef="country">
                <th mat-header-cell *matHeaderCellDef>Country</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.AddressCountryCode||'-' }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="recommendedACSLDisplayColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: recommendedACSLDisplayColumns"></tr>
            </table>
          </div>
          <mat-paginator class="custom-table-paginator" #aslPg [length]="totalCount" [pageSize]="pageSize" [pageIndex]="recommendedCurrentPage"
            [pageSizeOptions]="pageSizeOptions" (page)="onRecommendedChange($event)"
            *ngIf="recommendedDataSource.data.length > 0">
          </mat-paginator>
        </div>
      </mat-step>
      <mat-step *ngIf="!standardPurchaseModeView" [label]="stepperLabels.INPUT_JUSTIFICATION">
        <form [formGroup]="justificationForm">
          <div *ngFor="let field of fields">
            <label class="mb-2">{{field}}</label> <br>
            <textarea type="text" rows="4" cols="50" [formControlName]="field"></textarea>
          </div>
        </form>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
  
<div mat-dialog-actions class="custom-dialog-buttons">
  <ng-container *ngIf="!stepper || !stepper.selected || stepper.selected.label === stepperLabels.RECOMMENDED_ACLASL">
    <app-button class="padBtn cancel-button" name="Cancel" tabindex="0" (keypress)="dialogRef.close()"
      (click)="dialogRef.close()"></app-button>
    <button *ngIf="!noItemsYet && recommendedDataSource.data.length > 0" mat-flat-button color="primary"
      class="padBtn action-button" (keypress)="stepper.next()" (click)="stepper.next()"
      (click)="addRecommendedVendor()">Next</button>
  </ng-container>
  <ng-container *ngIf="stepper?.selected?.label === stepperLabels.INPUT_JUSTIFICATION">
    <app-button class="padBtn cancel-button" name="Cancel" tabindex="0" (keypress)="dialogRef.close()"
      (click)="dialogRef.close()"></app-button>
    <button mat-button class='padBtn secondary-button' color="primary" mat-stroked-button
      (keypress)="stepper.previous()" (click)="stepper.previous()">Previous</button>
    <button mat-flat-button color="primary" class="padBtn action-button" type="flat-button" type="submit" tabindex='0'
      (keypress)="submitAclAslVendors()" (click)="submitAclAslVendors()">Submit</button>
  </ng-container>
</div>
</div>